import { createFileRoute } from '@tanstack/react-router';

import Forbidden from '@/ui/pages/Forbidden';
import { sameOriginPath } from '@/utils/sameOriginPath';

/**
 * Access-denied screen, where `requireRoute` sends a session that may not open a route.
 *
 * It lives **inside** `_dashboard` on purpose: refusing one destination should not also strip the
 * navigation, and the user needs the rail to reach a section they can open. The route itself is
 * ungated — a guard on the refusal screen would loop.
 */
export const Route = createFileRoute('/_dashboard/forbidden')({
  /**
   * `?from=` is echoed back into the page, so it is untrusted input reaching the DOM. It is
   * narrowed to a same-origin path so the screen can never present `//evil.com` as "the page you
   * tried to open"; anything else collapses to `''`, which the page reads as "destination
   * unknown" and simply omits the line.
   *
   * HS-1396 moved the rule into `sameOriginPath` because the 404 screen needs exactly the same
   * one. Two hand-written copies of a check like this drift, and the copy that drifts is the one
   * nobody is looking at.
   */
  validateSearch: (search: Record<string, unknown>): { from: string } => ({
    from: sameOriginPath(search.from),
  }),
  component: Forbidden,
});
